import { CustomColumnGridConfig } from '../types'
import { Box, Modal } from '@mui/material'
import ImageIcon from '../../../../../assets/ImageIcon.svg'
import { useState } from 'react'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    minWidth: 150,
    field: 'water_connection_number',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'measurement_zone',
    headerName: 'איזור מדידה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'consumer_name',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'payer_number',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    field: 'replacement_date',
    headerName: 'תאריך החלפה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'replacement_reason',
    headerName: 'סיבת החלפה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    field: 'old_meter_number',
    headerName: 'מס’ מד ישן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'new_meter_number',
    headerName: 'מס’ מד חדש',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'old_meter_diameter',
    headerName: 'קוטר מד ישן',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    minWidth: 150,
    field: 'new_meter_diameter',
    headerName: 'קוטר מד חדש',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    minWidth: 150,
    field: 'removal_reading',
    headerName: 'קריאת פירוק',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    field: 'installation_reading',
    headerName: 'קריאת התקנה',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    field: 'old_meter_photo_url',
    headerName: 'צילום מד ישן',
    filterSpec: { kind: 'none' },
    filterable: false,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      const [openImage, setOpenImage] = useState(false)
      const handleOpenImage = () => setOpenImage(true)
      const handleCloseImage = () => setOpenImage(false)
      return (
        <Box>
          <img
            src={ImageIcon}
            alt="meter photo"
            onClick={() => handleOpenImage()}
          />
          <Modal open={openImage} onClose={handleCloseImage}>
            <Box sx={{ width: 'fit-content', marginLeft: '25%' }}>
              <img src={params.row.old_meter_photo_url} alt="meter photo" />
            </Box>
          </Modal>
        </Box>
      )
    },
  },
  {
    width: 150,
    field: 'new_meter_photo_url',
    headerName: 'צילום מד חדש',
    filterSpec: { kind: 'none' },
    filterable: false,
    hideable: true,
    disableAggregation: true,
    renderCell: (params: any) => {
      const [openImage, setOpenImage] = useState(false)
      const handleOpenImage = () => setOpenImage(true)
      const handleCloseImage = () => setOpenImage(false)
      return (
        <Box>
          <img
            src={ImageIcon}
            alt="meter photo"
            onClick={() => handleOpenImage()}
          />
          <Modal open={openImage} onClose={handleCloseImage}>
            <Box sx={{ width: 'fit-content', marginLeft: '25%' }}>
              <img src={params.row.new_meter_photo_url} alt="meter photo" />
            </Box>
          </Modal>
        </Box>
      )
    },
  },

  {
    width: 150,
    field: 'reason_not_performed',
    headerName: 'סיבת אי ביצוע',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
